module.exports = __webpack_public_path__ + "static/media/lena@2x.20f16a24.png";